import React, { useState, useEffect, useContext, useRef } from "react";
import { store } from "../../context/store";
import { functions } from "../../constants/common-functions";
import { useHistory, useParams } from "react-router-dom";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { STRINGIFY } from "../../constants/general-constants";
import background from "../../../images/background.jpg";
import FolderForagerTreePanel from "./components/FolderForagerTreePanel";
import FolderForagerHeader from "./components/FolderForagerHeader";
import FolderForagerDocumentsPanel from "./components/FolderForagerDocumentsPanel";
import FolderForagerDocumentPopup from "./components/FolderForagerDocumentPopup";
import useFolderForager
from "./hooks/useFolderForager";
import DocumentClassificationFilter
from "./components/DocumentClassificationFilter";
import ForgeViewer
from "../../components/ForgeViewer";

import MobileDocuments
from "./mobile/MobileDocuments";

import {
  OMNISCAN_BLUE
} from "../../constants/colors";

export default function Documents() {

  const globalState = useContext(store);
  const history = useHistory();
  
  const { id } = useParams();
  
  const
  {
      loading,

      directories,

      selectedDirectory,

      documents,

      selectedDocument,
	  
	  setSelectedDocument,

      expandDirectory,

      selectDirectory,

      selectDocument

  }
  =
  useFolderForager();
  
  
  useEffect(() =>
  {
      if (!directories.length)
          return;

      const dir =
          directories.find(d => d.id === Number(id));

      if (dir)
      {
          selectDirectory(dir);
      }

  }, [directories, id]);
  
  
  const [searchText,
         setSearchText] =
      useState("");
	  
	  
	  const [viewerType, setViewerType] =
	      useState(null);
	  
	  const [openDocumentUrl, setOpenDocumentUrl] =
	      useState(null);

	  const [openDocument, setOpenDocument] =
	      useState(null);
		  
     const [documentBlob, setDocumentBlob] = useState({})
	 
	 const [displayClassificationFilter,
	        setDisplayClassificationFilter] =
	     useState(false);
		 
	 const filteredDocuments =
	     documents.filter(doc =>
	         doc.title
	             .toLowerCase()
	             .includes(searchText.toLowerCase())
	 );
 

  // ---------------- STYLES ----------------

  const pageContainer = {
    position: "relative",
    minHeight: "100vh",
    overflowX: "hidden",   // only block sideways
    overflowY: "hidden"      // allow scrolling
  };

  const pageBackground = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",

    background:
      "radial-gradient(ellipse at center, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0.50) 35%, rgba(255,255,255,0.45) 65%, rgba(255,255,255,0.40) 100%)",

    zIndex: 0,
    pointerEvents: "none"
  };

  const thisContainer = {
    display: "flex",
    width: "100%",
    marginLeft: "50px",
    minHeight: "100vh",
    position: "relative",
    zIndex: 1
  };

  const explorerContainer =
  {
      display: "flex",
      width: "calc(100% - 90px)",
      height: "calc(100vh - 80px)",
      marginLeft: "75px",
      marginTop: "15px",
      gap: "18px"
  };
  
 

  const openFile = (doc) =>
  {
	 
      const extension =
          (doc.extension || "").toLowerCase();

      //
      // Forge Viewer
      //

      if (
          extension === "rvt" ||
          extension === "dwg" ||
          extension === "ifc" ||
          extension === "nwd"
      )
      {
          setViewerType("forge");
          setSelectedDocument(doc);
          setOpenDocument(doc);

          return;
      }

      //
      // SharePoint / PDF / Images
      //

      functions.getBlobFromAjax(
          "/resolutionsoftwareplatform/api/sharepoint/file/" +
          doc.sharePointId,
          function(blob)
          {
              const url =
                  window.URL.createObjectURL(blob);

              setViewerType("blob");
              setSelectedDocument(doc);
              setOpenDocument(doc);
              setOpenDocumentUrl(url);
          });
  }
 
 const openClassificationFilter = () =>
 {
     setDisplayClassificationFilter(true);
 };

 const closeClassificationFilter = () =>
 {
     setDisplayClassificationFilter(false);
 };
 
 
 const normaliseUrn = (urn) =>
 {
     if (!urn)
     {
         return null;
     }

     //
     // Remove any leading "urn:"
     //

     let cleaned =
         urn.replace(/^urn:/i, "");

     //
     // For the first test, remove the version too.
     //

     cleaned =
         cleaned.replace(/\?.*$/, "");

     return cleaned;
 };
 
 
 //--------------------------------------------------------
    // Mobile
    //--------------------------------------------------------

    const isMobile =
        window.innerWidth <= 768;

    if(isMobile)
    {
        return (
            <MobileDocuments />
        );
    }


  // ---------------- RENDER ----------------

  return (
    <div style={pageContainer}>
	  {/*<div style={overlayStyle}/>*/}
      {/* BACKGROUND */}
      <div style={pageBackground} />
	  
      {/* FOREGROUND */}
      <div style={thisContainer}>

        <Header showSurveySelector = {false} transitionHide={true}/>
        <LeftMenu />

		<FolderForagerTreePanel

		    directories={directories}

		    selectedDirectory={selectedDirectory}

		    onExpand={expandDirectory}

		    onSelect={selectDirectory}

		/>

		<FolderForagerHeader

		      directory={selectedDirectory}

		      documentCount={documents.length}

		      searchText={searchText}

		      onSearchChange={setSearchText}
			  
			  onClassificationClick={openClassificationFilter}

		  />  
		  
		  
		  <FolderForagerDocumentsPanel
		      documents={filteredDocuments}
		      selectedDocument={selectedDocument}
		      openFile={openFile}
			
		  />
		  {
		      viewerType === "blob" &&
		      openDocumentUrl &&
		      <>
		          <div
		              style={{
		                  position:"fixed",
		                  top:"0px",
		                  left:"50px",
		                  right:"0px",
		                  bottom:"0px",
		                  background:"rgba(255,255,255,.95)",
		                  overflow:"hidden",
		                  zIndex:400,
		                  boxShadow:
		                      "0 18px 45px rgba(0,0,0,.25)"
		              }}
		          >
		              <iframe
		                  src={openDocumentUrl}
		                  title={
		                      openDocument
		                          ?
		                          openDocument.title
		                          :
		                          "Document"
		                  }
		                  style={{
		                      width:"100%",
		                      height:"100%",
		                      border:"none"
		                  }}
		              />
		          </div>

		          <FolderForagerDocumentPopup
		              document={selectedDocument}
		              onClose={() =>
		              {
		                  setViewerType(null);
		                  setOpenDocumentUrl(null);
		                  setOpenDocument(null);
		                  setSelectedDocument(null);
		              }}
		          />
		      </>
		  }
		  {
		      viewerType === "forge" &&
		      openDocument &&
		      <>
		          <div
		              style={{
		                  position:"fixed",
		                  top:"0px",
		                  left:"50px",
		                  right:"0px",
		                  bottom:"0px",
		                  background:"rgba(255,255,255,.95)",
		                  overflow:"hidden",
		                  zIndex:400,
		                  boxShadow:
		                      "0 18px 45px rgba(0,0,0,.25)"
		              }}
		          >
		              <ForgeViewer

		                  urn={normaliseUrn(openDocument.forgeUrn)}

		                  viewerLeft="0px"
		                  viewerTop="0px"
		                  viewerRight="0px"
		                  viewerBottom="0px"

		              />
		          </div>

		          <FolderForagerDocumentPopup
		              document={selectedDocument}
		              onClose={() =>
		              {
		                  setViewerType(null);
		                  setOpenDocumentUrl(null);
		                  setOpenDocument(null);
		                  setSelectedDocument(null);
		              }}
		          />
		      </>
		  }
      </div>
	  
	  <DocumentClassificationFilter

	      displayFlag={displayClassificationFilter}

	      closeFunction={closeClassificationFilter}

	  />
	 
    </div>
  );
}

